import { Injectable, inject } from '@angular/core';

import { DatabaseService } from '@et/storage';

@Injectable({
  providedIn: 'root',
})
export class DataBaseResolver {
  private dbService = inject(DatabaseService);

  async resolve(): Promise<boolean> {
    try {
      // Always try to initialize if not initialized
      if (!this.dbService.isService) {
        await this.dbService.init();
        await this.dbService.setTables();
      } else {
        // Even if initialized, verify tables exist
        await this.dbService.setTables();
      }

      return true;
    } catch (error) {
      console.error(
        'DataBaseResolver: Error during database initialization:',
        error,
      );

      // Try to recover by forcing reinitialization
      try {
        await this.dbService.init();
        await this.dbService.setTables();
        return true;
      } catch (recoveryError) {
        console.error('DataBaseResolver: Recovery failed:', recoveryError);
        // Return true to allow the application to continue,
        // but log the error for debugging
        return true;
      }
    }
  }
}
